// Converts a 3-letter or 2-letter country code to a flag emoji
const alpha3ToAlpha2 = {
  // European countries
  ALB: 'AL', // Albania
  AND: 'AD', // Andorra
  ARM: 'AM', // Armenia
  AUT: 'AT', // Austria
  AZE: 'AZ', // Azerbaijan
  BEL: 'BE', // Belgium
  BIH: 'BA', // Bosnia and Herzegovina
  BLR: 'BY', // Belarus
  BUL: 'BG', // Bulgaria
  CRO: 'HR', // Croatia
  CYP: 'CY', // Cyprus
  CZE: 'CZ', // Czech Republic
  DEN: 'DK', // Denmark
  ENG: 'GB', // England
  ESP: 'ES', // Spain
  EST: 'EE', // Estonia
  FAI: 'FO', // Faroe Islands
  FIN: 'FI', // Finland
  FRA: 'FR', // France
  GEO: 'GE', // Georgia
  GER: 'DE', // Germany
  GRE: 'GR', // Greece
  HUN: 'HU', // Hungary
  IRL: 'IE', // Ireland
  ISL: 'IS', // Iceland
  ITA: 'IT', // Italy
  KOS: 'XK', // Kosovo
  LAT: 'LV', // Latvia
  LIE: 'LI', // Liechtenstein
  LTU: 'LT', // Lithuania
  LUX: 'LU', // Luxembourg
  MDA: 'MD', // Moldova
  MCO: 'MC', // Monaco
  MKD: 'MK', // North Macedonia
  MLT: 'MT', // Malta
  MNE: 'ME', // Montenegro
  NED: 'NL', // Netherlands
  NOR: 'NO', // Norway
  POL: 'PL', // Poland
  POR: 'PT', // Portugal
  ROU: 'RO', // Romania
  RUS: 'RU', // Russia
  SCO: 'GB', // Scotland
  SMR: 'SM', // San Marino
  SRB: 'RS', // Serbia
  SVK: 'SK', // Slovakia
  SVN: 'SI', // Slovenia
  SUI: 'CH', // Switzerland
  SWE: 'SE', // Sweden
  TUR: 'TR', // Turkey
  UKR: 'UA', // Ukraine
  VAT: 'VA', // Vatican City
  WAL: 'GB', // Wales
  // Non-European countries
  BRN: 'BH', // Bahrain
  CHN: 'CN', // China
  IND: 'IN', // India
  KAZ: 'KZ', // Kazakhstan
  PHI: 'PH', // Philippines
  SYR: 'SY', // Syria
  // ...add more as needed
};

export function countryCodeToFlag(code) {
  if (!code) return '';
  let cc = code.trim().toUpperCase();
  if (cc.length === 3) {
    if (alpha3ToAlpha2[cc]) {
      cc = alpha3ToAlpha2[cc];
    } else {
      return cc;
    }
  }
  if (cc.length !== 2) return '';
  return cc.replace(/./g, char =>
    String.fromCodePoint(127397 + char.charCodeAt())
  );
}
